export const EVENTS = {
  OPEN_NAG: 'OPEN_NAG',
  CLOSE_NAG: 'CLOSE_NAG',
  NAG_SELECTION_CONFIRMED: 'frontend-shell:cabin-bags:nag-selection-confirmed',
  NAG_LOADING_ERROR: 'frontend-shell:cabin-bags:nag-loading-error',
  BOARDING_OPTIONS_LOADED: 'frontend-shell:cabin-bags:boarding-options-loaded',
  BOARDING_OPTIONS_SELECTED:
    'frontend-shell:cabin-bags:boarding-options-selected',
};
